export const FolderTooltip = () => (
  <>
    Access configuration can be applied to the entire pond and all attached
    files (recommended), or to individual pond folders.
  </>
);
